// JsFromRoutes CacheKey 426cfb700fbdef1e069d2f03f8fb2ba1
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  update: /* #__PURE__ */ definePathHelper('patch', '/:account_id/team/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/:account_id/team/:id'),
}
